import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IHTTPResponse } from '../../../core-lib/interfaces/http-response';
import { ServiceRequestsFilters } from 'app/dashboard/models/WidgetDashboard.model.component';

@Injectable({
  providedIn: 'root',
})
export class DashnoardService {
  constructor(private http: HttpClient) {}

  getServiceRequests(filters: ServiceRequestsFilters): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}service-requests`;

    const params = new HttpParams()
      .set('customer_id', filters.customer_id?.toString() || '')
      .set('status_id', filters.status_id?.toString() || '')
      .set('page', filters.page?.toString() || '0')
      .set('size', filters.size?.toString() || '10');

    return this.http.get<IHTTPResponse>(url, { params });
  }

  getServiceRequestsStatuses(): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}service-requests/statuses`;

    return this.http.get<IHTTPResponse>(url);
  }

  updateServiceRequestStatus(serviceRequestId: number, statusId: number): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}service-requests/${serviceRequestId}/status`;

    return this.http.patch<IHTTPResponse>(url, { status_id: statusId });
  }
}
